import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createClient } from './createClient.js';
import { publicActions } from './decorators/public.js';
export function createPublicClient(parameters) {
  const {
    key = 'public',
    name = 'Public Client'
  } = parameters;
  const client = createClient(_objectSpread(_objectSpread({}, parameters), {}, {
    key,
    name,
    type: 'publicClient'
  }));
  return client.extend(publicActions);
}
//# sourceMappingURL=createPublicClient.js.map